import WIPFeaturesContext from 'context/wip-features/wip-features.context';
import { useI18n } from 'hooks/useI18n';
import { UIOfferWhereSection } from 'interfaces/ui/ui-offer-where-section';
import { useContext } from 'react';
import JobOfferLongText from '../JobOfferLongText';
import JobOfferSection from '../JobOfferSection';
import WhereOffice from './WhereOffice';
import WherePerks from './WherePerks';
import { StyledWhereContent, StyledWhereSection } from './WhereSection.styled';
import WhereSpaces from './WhereSpaces';
import WhereSummary from './WhereSummary';

const WhereSection = ({
  jobLocationsSummary,
  jobRemote,
  jobInfo,
  companyLogo,
  companyAddress,
  googleMaps,
  spacesSlides,
  officePerks,
  migratedToMarkdown,
  isFreelance
}: UIOfferWhereSection) => {
  const { t } = useI18n('job-offer');
  const showWIPFeatures = useContext(WIPFeaturesContext);

  return (
    <JobOfferSection
      name="donde"
      title={t(isFreelance ? 'titles.where_freelance' : 'titles.where')}
    >
      <StyledWhereSection>
        <WhereSummary
          jobLocationsSummary={jobLocationsSummary}
          jobRemote={jobRemote}
        />
        <JobOfferLongText isMarkdown={migratedToMarkdown}>
          {jobInfo}
        </JobOfferLongText>
        {showWIPFeatures && (
          <>
            <StyledWhereContent>
              <WhereOffice
                migratedToMarkdown={migratedToMarkdown}
                companyLogo={companyLogo}
                companyAddress={companyAddress}
                googleMaps={googleMaps}
              />
              <WhereSpaces spacesSlides={spacesSlides} />
            </StyledWhereContent>
            <WherePerks officePerks={officePerks} />
          </>
        )}
      </StyledWhereSection>
    </JobOfferSection>
  );
};

export default WhereSection;
